<template>
    <v-dialog v-model="dialog" max-width="600" persistent>
		<v-card>
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">{{ $term('employee', { case: 'title' }) }} Compliance Reminders</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text class="text-xs-left">
              <v-subheader  style="height: inherit;">This feature allows you to send out regular reminders to {{ $term('employee', { plural: true }) }} who have outstanding compliance items. Reminders will be sent out for the following:</v-subheader>
              
              <v-list dense>
                <v-list-tile
                    avatar
                >
                    <v-list-tile-action>
                        <v-icon color="success">check</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>HR policies pending acknowledgement</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="$_hasAccessToModule('positionDescriptions')"
                    avatar
                >
                    <v-list-tile-action>
                        <v-icon color="success">check</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ $term('positionDescription', { plural: true, case: 'sentence' }) }} pending acknowledgement</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                </v-list>
                <v-divider class="mt-2" />
              <div class="caption mt-3 mb-3" style="padding-left: 16px; color: rgba(0,0,0,.54);">Note: {{ $term('employee', { plural: true, case: 'sentence' }) }} will receieve a maximum of 1 reminder email per week. HR policies or {{ $term('positionDescription', { plural: true }) }} that were created or updated within the past week will not be included. Reminders will only be sent out on weekdays during typical working hours.</div>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-spacer></v-spacer>
				<v-btn flat @click="onClose">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			}
		},
		methods: {
			onClose() {
				this.$emit('onClose');
			}
		}
	};
</script>
